class FilterList {
    constructor() {
       this.dataTaxon = [];
       this.init();

       window.pubSubEvents.subscribe('hubsUpdate', (params) => {
            if (this.hasSearchUrl()) {
                this.filterListsByIds(params);
            } else {
             this.filterListsByCategories(params);
            }
       });
    }

    filterListsByIds(params) {
        if(params && params.length > 0) {
            this.getFilteredIds(params).then((ids) => {
                var foundLists = this.dataTaxon.filter(item => {
                    return item.hubId && ids.some((id) => item.hubId.toLowerCase() == id.toLowerCase());
                });
 
                if (foundLists) {
                    foundLists.forEach(elm => {
                        this.showList(elm);
                    });
                }
 
                const listsToHide = this.dataTaxon.filter((item) => foundLists.indexOf(item) === -1 && item.taxons.length > 0);
                if (listsToHide) {
                    listsToHide.forEach( el => this.hideList(el));
                }
                window.ListsContent.styleLists();
            });
        } else{
            this.dataTaxon.forEach(el => this.showList(el));
            window.ListsContent.styleLists();
        }

        
    }

    // Old
    filterListsByCategories(params) {
        if(params && params.length > 0) {
            this.params = params;
            let foundLists = [];
            foundLists = this.dataTaxon.filter(list => {
                if (!(list.hasOwnProperty('taxons') && ObjectHelper.isArray(list.taxons))) {
                    return false;
                }

                var taxaParams = params.filter((param) =>{
                    return !(param.hasOwnProperty('fieldName') || param.taxonName === 'year')
                });

                const taxas = list.taxons.slice();
                return taxaParams.every((param) => {
                     const foundTaxa = taxas.filter((tx) => {
                         return tx.taxonName.toLowerCase() === param.taxonName.toLowerCase();
                     });

                     if (foundTaxa.length > 0) {
                         const formattedParams = param.value.map(i =>
                            i.toLowerCase().replace(/-|\s/g, '')
                          );

                       return foundTaxa[0].value.some(val => formattedParams.includes(val.replace(/-|\s/g, '').toLowerCase()));
                     }

                     return false;
                });
             });


            if (foundLists) {
                    foundLists.forEach(elm => {
                        this.showList(elm);
                    });
                }

            const listsToHide = this.dataTaxon.filter((item) => foundLists.indexOf(item) === -1 && item.taxons.length > 0);
            if (listsToHide) {
                listsToHide.forEach( el => this.hideList(el));
            }
        } else{
            this.dataTaxon.forEach(el => this.showList(el));
        }

        window.ListsContent.styleLists();
        window.VoyageGridItemClassUpdaterLazy();
    }


    init() {
        const filter = document.querySelector('.filter-widget__wrapper');
        if(filter) {
            this.hideDuplicateElements();
        }

        const lists = document.querySelectorAll('[data-taxa]');
        lists.forEach(element => {
            const elId = element.getAttribute('id');
            const taxons = element.getAttribute('data-taxa');
            const hubId = element.getAttribute('data-hub-id');

            const listObj = {
                id: elId,
                hubId: hubId
            };

            if (taxons && taxons.length > 0) {
                listObj.taxons = JSON.parse(taxons);
            }

            this.dataTaxon.push(listObj);
        });

        this.searchUrl = window.contentHubResultServiceUrl;

        if (!this.searchUrl) {
            console.log('hub search not configured. Filtering by categories');
        }
    }

    hasSearchUrl(){
        return !!this.searchUrl;
    }

    hideList(el) {
        const listEl = document.getElementById(el.id);
         if(listEl && !listEl.classList.contains('do-not-show')) {
            listEl.classList.add('do-not-show');
        }
    }

    showList(el) {
        const listEl = document.getElementById(el.id);
         if(listEl && listEl.classList.contains('do-not-show')) {
            listEl.classList.remove('do-not-show');
        }
    }

    hideDuplicateElements() {
        const items = document.querySelectorAll('.card-lift');
        const links = [];
        items.forEach(item => {
            const href = item.querySelector('a').href;
            if(links.indexOf(href) === -1) {
                links.push(href);
            } else{
                item.classList.add('do-not-show');
            }
        });
    }

    getFilteredIds(obj) {
        const data = ElasticSearchHelper.buildFilterListRequestBody(obj);
        if(data)

        return new Promise((resolve, reject) => {
            APIHelper.post({
                url: this.searchUrl,
                data
            }).then((response) => {
                let hits = response.hits.hits;

                let ids = [];
                for (var i = 0; i < hits.length; i++) {
                    ids.push(hits[i]._id)
                }
    
                resolve(ids);
            })
        });
    }
}

export default FilterList;
